// extracted by mini-css-extract-plugin
export default {"container":"LocationsEditPage_container__fMvCU"};